module.exports = __webpack_public_path__ + "img/Arrow_Dropdown.207f81a6.svg";